import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrAaradhyaSharmacontent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Aaradhya Sharma"
      specialization="Obstetrics & Gynaecology"
      experience="11+ Years"
      degrees="MBBS, DGO, MD (Obs & Gyn)"
      quote="I believe I am becoming a safe space where mothers feel heard before they feel treated."
      sections={[
        {
          title: "My Philosophy on Pregnancy Care",
          body: "I believe pregnancy is a journey of the heart as much as it is of the body. My role is to be a calm, steady presence. I focus on creating a space free of judgment, where you can share your deepest anxieties and your greatest joys. I believe in blending evidence-based medicine with a deep respect for a mother's intuition. We are partners in this, and your feelings and instincts are a vital part of our shared plan for a healthy, happy pregnancy.",
        },
        {
          title: "Why I Chose Myprega",
          body: "Myprega's vision resonates deeply with how I've always wanted to practice medicine. In a traditional setup, time is a luxury. Here, the system is designed to foster connection. Myprega gives me the freedom and the tools to build the trusting, long-term relationships that I believe are essential for true maternal care.",
        },
        {
          title: "Beyond the Clinic",
          body: "When I'm not with my patients, you can find me tending to my small balcony garden. There's something so hopeful about watching things grow. I'm an avid reader of classic literature and believe stories teach us more about humanity than anything else.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "Sapiens - A Brief History of Humankind" },
        { icon: "🎵", label: "Favourite Singer", value: "Lata Mangeshkar" },
        { icon: "🍽️", label: "Favourite Pastime", value: "Semi-classical music\nGardening" },
      ]}
    />
  );
};

export default DrAaradhyaSharmacontent;
